import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderPage from "@/pages/OrderPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Policies from "@/pages/Policies";
import TrackOrder from "@/pages/TrackOrder";
import ScrollToTop from "@/components/ScrollToTop";

function StoreLayout({ children }) {
  return (
    <>
      <Header />
      <CartDrawer />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
            <Route path="/loja" element={<StoreLayout><Catalog /></StoreLayout>} />
            <Route path="/produto/:id" element={<StoreLayout><ProductDetail /></StoreLayout>} />
            <Route path="/checkout" element={<StoreLayout><Checkout /></StoreLayout>} />
            <Route path="/pedido/:id" element={<StoreLayout><OrderPage /></StoreLayout>} />
            <Route path="/rastrear" element={<StoreLayout><TrackOrder /></StoreLayout>} />
            <Route path="/admin/login" element={<StoreLayout><AdminLogin /></StoreLayout>} />
            <Route path="/admin" element={<StoreLayout><AdminDashboard /></StoreLayout>} />
            <Route path="/politica/:policySlug" element={<StoreLayout><Policies /></StoreLayout>} />
          </Routes>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
